"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const react_2 = require("@osmosys/react");
const hooks_1 = require("../../hooks");
const EditableTitleName_1 = require("../../../../routes/Private/Contexts/EditableTitleName");
exports.ConversionCanvasHeader = () => {
    const { state: { draft: { name }, draft, }, } = hooks_1.useConversionCanvas();
    const { dispatchCanvasAction } = hooks_1.useConversionCanvasUpdate();
    return (react_1.default.createElement(react_2.OsmosysDiv, { osysName: "ConversionCanvasHeader", className: "text-center mt-2", padding: true },
        react_1.default.createElement(EditableTitleName_1.EditableTitleName, { name: name, disabled: false, onChange: newName => {
                dispatchCanvasAction({
                    data: {
                        draft: Object.assign(Object.assign({}, draft), { name: newName }),
                    },
                    type: 'state',
                });
            } }),
        react_1.default.createElement("p", { className: "text-muted small text-center" }, "Conversion")));
};
//# sourceMappingURL=index.js.map